import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const DiscussionSection = ({ 
  title = <><span className="text-primary">Let's Discuss Your Scan to</span> BIM & Point Cloud to CAD Architecture Projects</>,
  subtitle = "Get in touch to meet our dedicated team of certified BIM Modelers and CAD Drafters, ready to turn your ideas into tailored solutions.",
  buttonText = "Book a Free Consultation"
}) => {
  return (
    <section className="discussion-section">
      <div className="discussion-content">
        <h2 className="discussion-title">
          {title}
        </h2>
        <p className="discussion-subtitle">
          {subtitle}
        </p>
        <button className="discussion-btn">
          {buttonText} <ArrowUpRight size={18} className="btn-arrow" />
        </button>
      </div>
    </section>
  );
};

export default DiscussionSection;
